exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.padding[data-v-40fc8ea5]{padding:10px;color:#424242\n}\n", "", {"version":3,"sources":["/app/frontend/src/screens/financeiro/components/AppModalModeloMemorial.vue"],"names":[],"mappings":";AAyCA,0BACE,aACA,aAAc;CACf","file":"AppModalModeloMemorial.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.padding {\n  padding: 10px;\n  color: #424242;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-40fc8ea5","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/financeiro/components/AppModalModeloMemorial.vue
// module id = wnAU
// module chunks = 11